
<button class="btn btn-lg w-100 w-xxl-auto btn-submit"
        [ngClass]="{
                    'btn-secondary': !active,
                    'btn-warning text-white': active,
                    'disabled': !active
                    }"
        (click)="onClickedOnSubmitButton()"
        name="{{name}}"
>
  {{ label }} <i class="ps-2 fa-solid fa-{{ icon }}" *ngIf="icon"></i>
</button>

<ng-container *ngIf="error">
  <div class="invalid-feedback">
    {{ errorMessage }}
  </div>
</ng-container>
